/*
 * 账户相关的 CGI 接口
 * author: zaleguo
 * time: 2020-04-01
 */

import { hasFeatureFlag } from '@/services';
import { smb_fetch, getAgpApiUrl, getAgpAgmsApiUrl } from '../../../fetch';

/**
 * 获取登录员工的信息
 * @return
 */
export const getAccountInfo = (data, isShowError = true) => {
  const url = getAgpApiUrl('auth', 'get_user');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取广点通代理商帐号信息
 * @param {object} data 请求数据
 */
export const getGDTAgencyInfo = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('agency', 'get');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取微信广告代理商帐号信息
 * @param {object} data 请求数据
 */
export const getWXAgencyInfo = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('wechat_agency', 'get');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

// 获取主体服务商信息
export const getMbInfo = (data = {}, isShowError = true) => {
  if (hasFeatureFlag('is_switch_group_management_interface')) {
    const url = getAgpApiUrl('agms/v1/agency_group', 'get');
    const params = $.extend(
      true,
      {
        method: 'GET',
      },
      data,
    );

    return smb_fetch(url, params, isShowError);
  }
  const url = getAgpApiUrl('bm', 'get');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

// 更新广点通代理商帐号信息
export const updateGdtAccountInfo = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('agency', 'update');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取区域列表
 * @return
 */
export const getAreaCodeList = (data, isShowError = true) => {
  const url = getAgpApiUrl('advertiser', 'get_area_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 查看MDMID已有的主体服务商帐号信息
 * @param {object} data
 */
export const getMdmidList = (data, isShowError = true) => {
  if (hasFeatureFlag('is_switch_group_management_interface')) {
    const url = getAgpApiUrl('agms/v1/agency_group', 'get_by_mdm');
    const params = $.extend(
      true,
      {
        method: 'GET',
      },
      data,
    );
    return smb_fetch(url, params, isShowError);
  }
  const url = getAgpApiUrl('bm', 'get_by_mdm');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 查询父子服务商: 子查父、父查子
 */
export const getParentSonList = (data, isShowError = false) => {
  const url = getAgpApiUrl('agency', 'get_parent_son_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 创建主体服务商
 * @param {object} data
 */
export const createBm = (data, isShowError = true) => {
  if (hasFeatureFlag('is_switch_group_management_interface')) {
    const url = getAgpApiUrl('agms/v1/agency_group', 'create');
    const params = $.extend(
      true,
      {
        method: 'POST',
      },
      data,
    );
    return smb_fetch(url, params, isShowError);
  }
  const url = getAgpApiUrl('bm', 'create');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 认领腾讯广告账户 (可以通过参数控制是否确认提交,还是只做检查)
 * @param {object} data
 */
export const bindGdtAgencyAccount = (data, isShowError = true) => {
  if (hasFeatureFlag('is_switch_group_management_interface')) {
    const url = getAgpApiUrl('agms/v1/agency_group', 'bind');
    const params = $.extend(
      true,
      {
        method: 'POST',
      },
      data,
    );
    return smb_fetch(url, params, isShowError);
  }

  const url = getAgpApiUrl('bm', 'bind_agency');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 * 提交腾讯广告账户认领，包括互斥逻辑 (可以通过参数控制是否确认提交,还是只做检查)
 * @param {object} data
 */
export const applyBindGdtAgencyAccount = (data, isShowError = true) => {
  const url = getAgpApiUrl('agms/v2/agency_group', 'bind/create');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 * 认领微信广告账户 (可以通过参数控制是否确认提交,还是只做检查)
 * @param {object} data
 */
export const bindWechatAgencyAccount = (data, isShowError = true) => {
  const url = getAgpAgmsApiUrl('agency_group', 'wechat_bind');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 提交腾讯广告账户认领，包括互斥逻辑 (可以通过参数控制是否确认提交,还是只做检查)
 * @param {object} data
 */
export const applyBindWechatAgencyAccount = (data, isShowError = true) => {
  const url = getAgpApiUrl('agms/v2/agency_group', 'wechat_bind/create');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};
/**
 * 更新备注
 * @param {object} data
 */
export const updateRemark = (data, isShowError = true) => {
  const url = getAgpApiUrl('agency', 'update_remark');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取服务商保证金状态
 * @param {object} data
 */
export const getBondStatus = (data, isShowError = true) => {
  const url = getAgpApiUrl('bond', 'get_uid_deposit_status');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * 获取服务商保证金入口状态
 * @param {object} data
 */
export const getBondShowStatus = (data, isShowError = true) => {
  const url = getAgpApiUrl('bond', 'get_uid_show_deposit');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );
  return smb_fetch(url, params, isShowError);
};

/**
 * @description 创建服务商子帐号
 * @return
 */
export const createSubAgency = (data, isShowError = true) => {
  const url = getAgpApiUrl('bm_agency', 'create_sub_agency');
  const params = {
    method: 'POST',
    timeout: 0,
    data,
  };

  return smb_fetch(url, params, isShowError);
};

/**
 * @description 获取uid的所有 保证金类型
 * @return
 */
export const getUidDepositType = (data, isShowError = true) => {
  const url = getAgpApiUrl('bond', 'get_uid_deposit_type');
  const params = {
    method: 'POST',
    data,
  };

  return smb_fetch(url, params, isShowError);
};

/**
 * @description 获取二代服务商注册链接
 * @return
 */
export const getInviteLink = (data, isShowError = true) => {
  const url = '/agp/agms/v1/agency/invite-link/gen';
  const params = {
    method: 'POST',
    contentType: 'application/json',
    data,
  };

  return smb_fetch(url, params, isShowError);
};

/**
 * @description 获取服务商对应的渠道经理列表
 * @return
 */
export const getChannelManagersByAgency = (data, isShowError = true) => {
  const url = '/agp/agms/v1/agency/channel-manager/get';
  const params = {
    method: 'POST',
    contentType: 'application/json',
    data,
  };

  return smb_fetch(url, params, isShowError);
};

/**
 * @description 获取服务商对应资质列表
 * @return
 */
export const getLicenseList = (data, isShowError = true, needAgencyUid = false) => {
  const url = '/agp/agms/v1/agency/licence-list/get';

  const params = {
    method: 'POST',
    contentType: 'application/json',
    data,
  };

  return smb_fetch(url, params, isShowError, needAgencyUid);
};

export default {
  getAccountInfo,
  getGDTAgencyInfo,
  getWXAgencyInfo,
  getMbInfo,
  getAreaCodeList,
  updateGdtAccountInfo,
  getMdmidList,
  getParentSonList,
  bindGdtAgencyAccount,
  bindWechatAgencyAccount,
  createBm,
  updateRemark,
  getBondStatus,
  getBondShowStatus,
  createSubAgency,
  getUidDepositType,
  getInviteLink,
  getChannelManagersByAgency,
  getLicenseList,
  applyBindGdtAgencyAccount,
  applyBindWechatAgencyAccount,
};
